import { Component, Input, Output, EventEmitter, SimpleChanges} from '@angular/core';
import { PlatformService, NotificationsService, LoggingService, TokenService, LocalStorageService, SelectableTicket } from '@varsity/services';
import { BaseComponent } from '@varsity/components';

import { ToastController, PopoverController } from 'ionic-angular';
import { trigger, state, style, animate, transition, keyframes } from '@angular/animations';
import { Subject, BehaviorSubject } from 'rxjs';
import { InAppBrowser } from '@ionic-native/in-app-browser';
/**import { InAppBrowser } from '@ionic-native/in-app-browser';
 * Generated class for the AccountFooterComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'account-footer',
    templateUrl: 'account-footer.html',
    animations: [
        trigger("animatePopout", [
            state('hide',
                style({
                    background: '*'
                })),
                
            state('show',
                style({
                    background: '*'
                })
            ),
            transition('* => show', animate('1000ms', keyframes([
                style({ transform: "scale(1.3)", offset: 0.25 }),
                style({ transform: "scale(1.15)", offset: 0.5 }),
                style({ transform: "scale(1.0)", offset: 0.75}),
            ])
                
            ))
        ])
    ]
})
export class AccountFooterComponent extends BaseComponent { 
    
    // Add @Input for component/template binding
    @Input() public printEnabled: boolean;
    @Input() public validateEnabled: boolean;
    @Input() public transferEnabled: boolean;
    @Input() public textEnabled: boolean;
    @Input() public walletEnabled: boolean;
    @Input() public displayEnabled: boolean;
    @Input() public filterEnabled: boolean;
    @Input() public showValidate: boolean;
    @Input() public showTransfer: boolean;
    @Input() public showText: boolean;
    @Input() public showDisplay: boolean;
    @Input() public showPrint: boolean;
    @Input() public showAddToWallet: boolean;
    @Input() public showFilter: boolean;
    @Input() public numberOfTickets: number;
    @Input() public tickets: any[];

    @Output() public onPrintClicked: EventEmitter<any> = new EventEmitter();
    @Output() public onValidateClicked: EventEmitter<any> = new EventEmitter();
    @Output() public onTransferClicked: EventEmitter<any> = new EventEmitter();
    @Output() public onTextClicked: EventEmitter<any> = new EventEmitter();
    @Output() public onDisplayClicked: EventEmitter<any> = new EventEmitter();
    @Output() public onAddToWalletClicked: EventEmitter<any> = new EventEmitter();
    @Output() public onFilterClicked: EventEmitter<any> = new EventEmitter();

    showIOS: boolean = false;
    walletLabel: string = "Google Play";
    animationState: string = "";

    constructor(
        protected platformService: PlatformService,
        protected notificationsService: NotificationsService,
        protected loggingService: LoggingService,
        protected tokenService: TokenService,
        protected toastCtrl: ToastController,
        protected localStorageService: LocalStorageService,
        protected popoverCtrl: PopoverController,
        protected iab: InAppBrowser,
    ) {
        super(
            loggingService, tokenService, localStorageService,
            notificationsService, platformService, toastCtrl, popoverCtrl, iab,
            "AccountFooterComponent");
    }

    ngOnInit() {
        super.ngOnInit();

        this.platformService.platformType$
            .takeUntil(this.componentDestroyed$)
            .subscribe((value) => {
                if (value == "ios") {
                    this.showIOS = true;
                    this.walletLabel = "Apple Wallet";
                } else {
                    this.showIOS = false;
                    this.walletLabel = "Google Play";
                }
            });
    }

    ngOnChanges(changes: SimpleChanges) {
        for (let propName in changes) {
            if (propName == "numberOfTickets") {
                let chng = changes[propName];
                let cur = JSON.stringify(chng.currentValue);
                let prev = JSON.stringify(chng.previousValue);
                if (cur !== prev) {
                    this.animationState = "show";
                }
                this.loggingService.debug(`${propName}: currentValue = ${cur}, previousValue = ${prev}`);
            }
            
        }
    }

    printClicked() {
        this.onPrintClicked.emit();
    }

    validateClicked() {
        this.onValidateClicked.emit();
    }

    transferClicked() {
        this.onTransferClicked.emit();
    }

    textClicked() {
        this.onTextClicked.emit();
    }

    displayClicked() {
        this.onDisplayClicked.emit();
    }

    filterClicked() {
        this.onFilterClicked.emit();
    }

    goToAddToWallet() {
        this.onAddToWalletClicked.emit();
    }

    finishAnimation(): void {
        this.animationState = 'hide';
    }

    getNumberOfTicketsForTransfer() {
        return (this.tickets as SelectableTicket[]).filter(p => p.IsSelected && p.TicketAccountActions.ShowTransfer).length;
    }
}



// WEBPACK FOOTER //
// ./src/components/account-footer/account-footer.ts